__turbopack_context__.v({
  "answer": "ScriptSuggestions-module____i4OG__answer",
  "answerText": "ScriptSuggestions-module____i4OG__answerText",
  "arrow": "ScriptSuggestions-module____i4OG__arrow",
  "arrowOpen": "ScriptSuggestions-module____i4OG__arrowOpen",
  "container": "ScriptSuggestions-module____i4OG__container",
  "count": "ScriptSuggestions-module____i4OG__count",
  "head": "ScriptSuggestions-module____i4OG__head",
  "headStatic": "ScriptSuggestions-module____i4OG__headStatic",
  "item": "ScriptSuggestions-module____i4OG__item",
  "label": "ScriptSuggestions-module____i4OG__label",
  "list": "ScriptSuggestions-module____i4OG__list",
  "placeholder": "ScriptSuggestions-module____i4OG__placeholder",
  "title": "ScriptSuggestions-module____i4OG__title",
});
